import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = {
  active_holiday: "general",
  christmas_banner_text: "",
  mothers_day_banner_text: "",
  easter_banner_text: "",
  fathers_day_banner_text: "",
  halloween_banner_text: "",
};

const CampaignCtx = createContext({ campaign: DEFAULT, reload: () => {} });

export function CampaignProvider({ children }) {
  const [campaign, setCampaign] = useState(DEFAULT);
  const reload = useCallback(() => {
    api.get("/campaign").then((r) => setCampaign({ ...DEFAULT, ...r.data })).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <CampaignCtx.Provider value={{ campaign, reload }}>{children}</CampaignCtx.Provider>;
}

export const useCampaign = () => useContext(CampaignCtx);

export const HOLIDAYS = [
  { value: "general",     label: "General",       theme: null },
  { value: "christmas",   label: "Christmas",     theme: "bg-gradient-to-r from-[#7B1414] via-[#A0202F] to-[#0E5C2F] text-[#F5F5DC]" },
  { value: "mothers_day", label: "Mother's Day",  theme: "bg-gradient-to-r from-[#A4326D] via-[#C95E9C] to-[#6B3B7D] text-white" },
  { value: "easter",      label: "Easter",        theme: "bg-gradient-to-r from-[#F2E69A] via-[#C8E8A8] to-[#A2D5B6] text-[#3A2E10]" },
  { value: "fathers_day", label: "Father's Day",  theme: "bg-gradient-to-r from-[#0F2545] via-[#1B3A6B] to-[#8B7239] text-[#F5F5DC]" },
  { value: "halloween",   label: "Halloween",     theme: "bg-gradient-to-r from-[#000000] via-[#ff8c00] to-[#000000] text-[#FFF4E0]" },
];

export function bannerTextFor(campaign) {
  if (!campaign) return "";
  const key = `${campaign.active_holiday}_banner_text`;
  return campaign[key] || "";
}

export function themeFor(holiday) {
  return HOLIDAYS.find((h) => h.value === holiday)?.theme || null;
}
